import React, { Component } from 'react';

import ReactHtmlParser from 'react-html-parser';
export default class SingleItem extends Component {
    render() {
        return (
            <div
                className={`o-flex c-plans__how-it-works--item ${
                    this.props.leftSide ? 'how' : ''
                }`}
            >
                <h4>{this.props.item.title}</h4>
                <div
                    style={{ backgroundImage: `url(${this.props.item.image})` }}
                ></div>
                <p>
                    {ReactHtmlParser(
                        this.props.item.body ? this.props.item.body : ''
                    )}
                </p>
            </div>
        );
    }
}
